import { useEffect, useState } from 'react';
import api from '../api';

// Every coach's small avatar, fetched ONCE per page, keyed by coach id.
//
// Submissions and Bills show the same twenty-odd coaches across hundreds of
// rows, and that number only grows. Loading a picture per row would mean the
// same face fetched over and over on one screen and those pages getting slower
// every month. One request, one lookup table, and the cost is fixed by how
// many coaches the club has rather than how long it has been running.
//
// Returns a plain object: { [coach_id]: 'data:image/jpeg;base64,...' }.
// A coach with no photo is simply not in it, and <Avatar> draws their
// initials. A failed request leaves it empty, so the worst case is a page of
// initials rather than a page that will not load.
const useCoachAvatars = () => {
  const [avatars, setAvatars] = useState({});

  useEffect(() => {
    // If the page unmounts while this is in the air, do not set state on the
    // way back — that is the React warning nobody ever gets round to fixing.
    let live = true;
    api.get('/api/coaches/avatars')
      .then(res => {
        if (!live) return;
        const map = {};
        (res.data || []).forEach(a => { map[a.coach_id] = a.small; });
        setAvatars(map);
      })
      .catch(() => {
        // A missing photo is never worth breaking a page over.
        if (live) setAvatars({});
      });
    return () => { live = false; };
  }, []);

  return avatars;
};

export default useCoachAvatars;
